import { gql } from '@apollo/client';

import { assessmentWorksheetsFragment } from 'approot/assessment/sections/worksheets/worksheets.graphql';
import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';

export const assessmentAssignFragment = gql`
  fragment AssessmentAssignFragment on Assessment {
    id
    isAssigned
    assignedData {
      selfAssessment
      differentiationPages
      basicAssessmentPages
      summativeAssessmentPages
      formativeAssessmentPages
      stimulusResourceIds
      activitiesBookmarks {
        version
        sectionIds
      }
    }
  }
`;

export const GET_ASSESSMENT_ASSIGN_DATA = gql`
  query GetAssessmentAssignData($input: GetAssessmentByIdInput!) {
    getAssessmentById(input: $input) {
      ...AssessmentAssignFragment
      ...AssessmentWorksheetsFragment
      stimulusResources {
        ...StimulusResource
      }
    }
  }
  ${assessmentAssignFragment}
  ${stimulusResourceFragment}
  ${assessmentWorksheetsFragment}
`;
